import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg id="uuid-dec3b669-f2c0-4dc6-b173-3095b8742866" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" {...props}><path d="M14.722 10.672L23.419.563h-2.061L13.807 9.34 7.776.563H.82l9.12 13.273L.82 24.437h2.061l7.974-9.269 6.369 9.269h6.956l-9.458-13.765zm-2.823 3.281l-.924-1.322L3.623 2.115h3.165l5.933 8.487.924 1.322 7.713 11.032h-3.165l-6.294-9.002z" fill="#fff" strokeWidth="0" /></svg>);